import { Env } from '@stencil/core';

export interface IEnv {
  BUILD_STAGE: 'dev' | 'prod';
  gebaerdenSprachEndpoint:string;
  leichteSprachEndpoint:string;
  sucheEndpoint: string;
  glockenEndpoint: string;
  profilEndpoint:string;
  bescheideEndpoint:string;
  termineEndpoint:string;
  verlaufEndpoint:string;
  einstellungenEndpoint:string;
  maintenanceInfoUrl: string;
  apiClientId: string;

  ENV_JOBSUCHE_URL: string;
  ENV_ARBEITSLOSENGELD_URL: string;
  ENV_KINDERZUSCHLAG_URL: string;
  ENV_EINGLIEDERUNGSZUSCHUSS_URL: string;
  ENV_BETRIEBSNUMMER_URL: string;
  ENV_PROFIL_URL: string;
}

export default function getEnv(): IEnv {
  const env = {...Env} as unknown as IEnv;
  return Object.freeze(env);
}
